import { useNavigate } from 'react-router-dom';
import placeholder_cover_1600x700 from "@/assets/imgs/placeholders/cover_1600x700.jpg";
import FormattedText from '@/components/shared/FormattedText';
import SafeImg from '@/components/shared/SafeImg';

/**
 * 世界卡片組件
 * 用於世界列表頁面
 */
const WorldCard = ({ world }) => {
  const navigate = useNavigate();
  const {
    world_uuid,
    world_title,
    world_content,
    world_cover_url
  } = world;

  const handleClick = () => {
    if (world_uuid) {
      navigate(`/world-view/${world_uuid}`);
    }
  };

  return (
    <div className="content-card bg-white rounded shadowA">
      {/* 封面圖 + 標題（可點擊） */}
      <div className="cursor-p hover-opacity" onClick={handleClick}>
        <div className="content-card-cover rounded-top overflow-hidden img-cover">
          <SafeImg
            src={world_cover_url || placeholder_cover_1600x700}
            alt={world_title}
          />
        </div>
        <div className="px-3">
          <h5 className="text-center my-3 line-clamp-1">{world_title}</h5>
        </div>
      </div>

      {/* 內文（最多兩行）- padding 放外層避免與 line-clamp 衝突 */}
      {world_content && (
        <div className="px-3 pb-3">
          <div className="text-gray line-clamp-2">
            <FormattedText text={world_content} />
          </div>
        </div>
      )}
    </div>
  );
};

export default WorldCard;
